import { getFulfillmentsForFulfillmentPlan } from '../../../store/scan-to-print/s2p-purchase-and-print.actions';
import Global from '../../../store/global-selectors';

export default (state, jobId) => {
  const jobData = Global.selectJobPipelineJobDataByJobId(state, { jobId });
  const { fulfillmentPlanId } = jobData;
  return [getFulfillmentsForFulfillmentPlan(fulfillmentPlanId, jobId)];
};
